import React from "react";
import Layout from "../../components/UI/layout";
import { SEO as Seo } from "../../components/UI/seo";
import Banner from "../../components/Service/Banner/banner";
import OptionsComponent from "../../components/Service/Options/options";
import ManualsComponent from "../../components/Service/Manuales/manuals";

const ManualesPage = () => {
  return (
    <Layout>
      <Banner title="Manuales" />
      <OptionsComponent selectedOption="manuales" />
      <ManualsComponent />
    </Layout>
  );
};

export default ManualesPage;

export const Head = () => (
  <Seo
    title="Manuales originales | Peabody Argentina"
    description="Encontrá y descargá aquí todos los manuales oficiales de los productos Peabody. Los podés buscar ingresando el nombre, la categoría o código del producto."
  >
    <link rel="canonical" href="https://peabody.com.ar/servicio-tecnico/manuales/" />
  </Seo>
);
